<div class="row border-bottom">
  <div class="flex align-center"><span class="font-24 navy-blue-color">My Vehicles</span><button mat-flat-button
      class="addVehicle" (click)="onClickAddVehicle()">
      <span class="leftTitle">+ Add Vehicle</span>
    </button></div>
  <div class="addVehicle mt-15">

    <div class="flex-row mt-15">
      <div><img class="carImage1" src="../assets/hondaAccord.png" alt="" aria-hidden="true" />
        <p>Taimoor's A</p>
      </div>
      <div><img class="carImage1" src="../assets/hondaAccord.png" alt="" aria-hidden="true" />
        <p>Taimoor's B</p>
      </div>
    </div>
  </div>
</div>